import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit,
} from '@angular/core';
import { ICharacterConfig } from 'src/app/api/interfaces/character.interface';

@Component({
  selector: 'app-character-skin',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './character-skin.component.html',
  styleUrls: ['./character-skin.component.scss'],
})
export class CharacterSkinComponent implements OnInit {
  @Input() config: ICharacterConfig | undefined = {
    attribute: 2,
    body: 1,
    cloth: 5,
    face: 3,
    hair: 2,
    gender: 'FEMALE',
  };
  constructor() {}

  ngOnInit(): void {}
}
